export const buttons = {
    next: 'button.next',
    copyTooltip: 'button.copy.tooltip',
    done: 'button.done',
    sortTooltip: 'button.sort.tooltip',
    continue: 'button.continue',
    back: 'button.back',
    submit: 'button.submit',
    ok: 'button.ok',
    save: 'button.save',
    cancel: 'button.cancel',
    discard: 'button.discard',
    delete: 'button.delete',
    continueEditing: 'button.continue.editing',
    verify: 'button.verify',
    addVariable: 'button.add.variable',
    create: 'button.create',
    close: 'button.close',
    download: 'button.download',
    verifyAndSave: 'button.verify.save',
    resend: 'button.resend',
    search: 'button.search',
    clear: 'button.clear',
    remove: 'button.remove',
    block: 'button.block',
    unblock: 'button.unblock',
    readMore: 'button.read.more',
    export: 'button.export.btn',
    attachFile: 'button.attach.file',
}

export const links = {
    learnMore: 'link.learn.more',
    here: 'link.here'
}

export const common = {
    copied: 'common.copied',
    optional: 'common.optional',
    characters: 'common.characters',
    minutes: 'common.minutes',
    minute: 'common.minute',
    noData: 'common.no.data.title',
    search: 'common.search',
    edit: 'common.edit',
    delete: 'common.delete',
    statusNA: 'common.status.na',
    downloaded: 'common.downloaded',
    downloadFiled: 'common.download.failed',
    all: 'common.all',
    seeDetails: 'common.see.details',
    hideDetails: 'common.hide.details',
    downloadFailed: 'common.download.failed.message',
    from: 'common.from',
    notAvailable: 'common.not.available',
    year: 'common.year.label',
    years: 'common.years.label',
    month: 'common.month.label',
    months: 'common.months.label',
    day: 'common.day.label',
    days: 'common.days.label',
    tryAgain: 'common.try.again.label',
}

export const forms = {
    languageDefault: 'language.form.default.select',
    countryDefault: 'country.form.default.select',
    countryCodeDefault: 'country.code.form.default.select',
    timezoneDefault: 'timezone.form.default.select',
    generalTextPlaceholder: 'text.field.general.placeholder',
    fileInputDefaultFileName: 'file.input.default.file.name',
    fileSelectLabel: 'file.input.choose.file.label'
}

export const filters = {
    channelDefault: 'channel.filter.default.select',
    statusDefault: 'status.filter.default.select',
}

export const lookups = {
    channelWhatApp: 'lookups.channel.whatsapp',
    channelSms: 'lookups.channel.sms',
    packageStatusActive: 'lookups.account.package.active',
    packageStatusConsumed: 'lookups.account.package.consumed',
    packageStatusExpired: 'lookups.account.package.expired',
    statusInactive:'lookups.status.inactive',
    statusActive:'lookups.status.active'

}

export const messageFilters = {
    channelDefault: 'channel.filter.default.select',
    statusAll: 'status.filter.all.select',
    statusPending: 'status.filter.pending.select',
    statusDeleivered: 'status.filter.delivered.select',
    statusHalted: 'status.filter.halted.select',
    statusFailed: 'status.filter.failed.select',
    statusSent: 'status.filter.sent.select',
}

export const messageTypeFilters = {
    msgTypeAll: 'msg.type.filter.all.select',
    msgTypeText: 'msg.type.filter.text.select',
    msgTypeReaction: 'msg.type.filter.reaction.select',
    msgTypeImage: 'msg.type.filter.image.select',
    msgTypeDocument: 'msg.type.filter.document.select',
    msgTypeVideo: 'msg.type.filter.video.select',
    msgTypeSticker: 'msg.type.filter.sticker.select',
    msgTypeAudio: 'msg.type.filter.audio.select',
    msgTypeUnknown: 'msg.type.filter.unknown.select',
    msgTypeButton: 'msg.type.filter.button.select',
    msgTypeInteractive: 'msg.type.filter.interactive.select',
    msgTypeOrder: 'msg.type.filter.order.select',
    msgTypeSystem: 'msg.type.filter.system.select',
    msgTypeLocation: 'msg.type.filter.location.select',
    msgTypeContacts: 'msg.type.filter.contacts.select'
}

export const currency ={
    SAR: 'currency.sar'
}

export const paymentMethods= {
    card: 'payment.method.card.label',
    mada: 'payment.method.mada.label',
    applepay:'payment.method.applepay.label',
    samsungpay: 'payment.method.Samsungpay.label',
    stcpay: 'payment.method.stcpay.label',
    benefitpay: 'payment.method.benefitpay.label',
    knet:'payment.method.knet.label'
}